import { render, staticRenderFns } from "./PWStudio.vue?vue&type=template&id=4626a9e6&scoped=true&"
import script from "./PWStudio.vue?vue&type=script&lang=js&"
export * from "./PWStudio.vue?vue&type=script&lang=js&"
import style0 from "./PWStudio.vue?vue&type=style&index=0&id=4626a9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626a9e6",
  null
  
)

component.options.__file = "PWStudio.vue"
export default component.exports